<template>
  <div>
    <button
      type="button"
      class="btn"
      :id="id"
      :class="{
        'btn-primary': primary,
        'btn-danger': danger,
        'btn-outline-primary': outline,
        ' btn-outline-danger': outlineDanger,
        'btn-long': full,
      }"
      :disabled="disable"
      @click="action"
    >
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
      <span class="d-flex justify-content-center align-items-center">
        <img class="icon-16 m-r-10" v-if="edit" src="@/assets/icons/edit_2.svg" alt="" />
        <img class="icon-16 m-r-10" v-if="galeri" src="@/assets/icons/photograph.svg" alt="" />
        <span v-if="!loading" v-html="text"></span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "SOButton",
  props: {
    primary: Boolean,
    danger: Boolean,
    outline: Boolean,
    outlineDanger: Boolean,
    full: Boolean,
    loading: Boolean,
    disable: Boolean,
    edit: Boolean,
    galeri: Boolean,

    text: String,
    id: String,
  },
  methods: {
    action(payload) {
      this.$emit("action", payload);
    },
  },
};
</script>
<style scoped>
.view-iframe .btn-outline-primary {
  background-color: #fff;
}
</style>
